import { render, staticRenderFns } from "./stepUi.vue?vue&type=template&id=077fc6da&scoped=true&"
import script from "./stepUi.vue?vue&type=script&lang=js&"
export * from "./stepUi.vue?vue&type=script&lang=js&"
import style0 from "./stepUi.vue?vue&type=style&index=0&id=077fc6da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077fc6da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('077fc6da')) {
      api.createRecord('077fc6da', component.options)
    } else {
      api.reload('077fc6da', component.options)
    }
    module.hot.accept("./stepUi.vue?vue&type=template&id=077fc6da&scoped=true&", function () {
      api.rerender('077fc6da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taskMgr/templateMgr/components/maintenanceAidType/stepUi.vue"
export default component.exports